import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { theme } from '@components-shared/src/stitches';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const DeleteShelfMenuItem = ({ onClick }: { onClick: () => void }) => {
  return (
    <DropdownMenuItem onClick={onClick}>
      <FontAwesomeIcon icon={faTrashCan} color={theme.colors.destructive700.toString()} size="lg" />
      <MenuItemLabel css={{ color: '$destructive700', marginLeft: 8 }}>
        Delete playlist
      </MenuItemLabel>
    </DropdownMenuItem>
  );
};
